// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Redirect from deprecated singular route to plural route.
 */
export const Route = createFileRoute('/_app/exchange/')({
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/exchanges',
      search,
    });
  },
});
